import { SheetFooter } from '@/components/ui/sheet'
import { Skeleton } from '@/components/ui/skeleton'

export const AddExceptionSheetFallback = () => {
  return (
    <>
      <div className="flex-1 overflow-y-auto px-4 space-y-4">
        <Skeleton className="h-9 w-full" />
      </div>
      <SheetFooter className="sticky">
        <Skeleton className="h-9 w-full" />
      </SheetFooter>
    </>
  )
}
